import { VOTE } from '../../../store/votes';

export const getValueFromVoteType = (voteType) => {
  switch (voteType) {
    case VOTE.NONE:
      return 0;
    case VOTE.UP:
      return 1;
    case VOTE.QUESTION:
      return 2;
    case VOTE.DOWN:
      return 3;
    default:
      throw new Error(`Unknown vote type: ${voteType}`);
  }
};

export const getVoteType = (numberVoteType) => {
  switch (numberVoteType) {
    case undefined:
    case 0:
      return VOTE.NONE;
    case 1:
      return VOTE.UP;
    case 2:
      return VOTE.QUESTION;
    case 3:
      return VOTE.DOWN;
    default:
      throw new Error(`Unknown numberVoteType ${numberVoteType}`);
  }
};
